import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcLoad24Icon, IcLoadIcon } from '@gem/icons';

import { useFileDownloadStatePresenter } from 'APP/hooks/useFileDownloadState/useFileDownloadState';
import { InfiniteUploadIcon } from 'APP/main/components/InfiniteUploadIcon/InfiniteUploadIcon';
import { ProgressLoadIcon } from 'APP/main/components/ProgressLoadIcon/ProgressLoadIcon';

import styles from './MediaDownloadState.styles.m.css';

export type TLoadIconSize = '0' | '10';

interface IMediaDownloadStateProps {
  groupId: string;
  messageId: string;
  payloadId: string;
  className?: string;
  loadIconSize?: TLoadIconSize;
}

export const MediaDownloadState: FC<IMediaDownloadStateProps> = observer((props) => {
  const { className, groupId, messageId, payloadId, loadIconSize = '10' } = props;

  const presenter = useFileDownloadStatePresenter({ payloadId, groupId, messageId });

  const LoadIcon = loadIconSize === '0' ? IcLoad24Icon : IcLoadIcon;

  if (presenter.isDownloadInProcess) {
    return (
      <div className={classNames(styles.container, className)}>
        <ProgressLoadIcon
          Icon={LoadIcon}
          progress={presenter.downloadPercent}
          onClick={(e): void => {
            e.stopPropagation();
            presenter.onAbort();
          }}
        />
      </div>
    );
  } else if (presenter.isWaitingDownloadProcess) {
    return (
      <div className={classNames(styles.container, className)}>
        <InfiniteUploadIcon
          Icon={LoadIcon}
          onClick={(e): void => {
            e.stopPropagation();
            presenter.onAbort();
          }}
        />
      </div>
    );
  }

  return null;
});
